import { Button, HFlow, Modal, ModalBody, ModalFooter, ModalHeader, Text } from 'bold-ui'

interface ModalUnificarBasesProps {
  isModalOpen: boolean
  setIsModalOpen(isOpen: boolean): void
  onUnificarBase(): void
}

export const ModalUnificarBases = (props: ModalUnificarBasesProps) => {
  const { isModalOpen, setIsModalOpen, onUnificarBase } = props
  const handleFecharModal = () => setIsModalOpen(false)
  const onUnificarClicked = () => {
    onUnificarBase()
    handleFecharModal()
  }

  return (
    <Modal open={isModalOpen} onClose={handleFecharModal} size='small' closeOnBackdropClick={true}>
      <ModalHeader title='Atenção' icon={{ name: 'exclamationTriangleOutline', fill: 'alert' }} />
      <ModalBody>
        <Text>
          Ao continuar com a ação de Unificação de Bases, os dados dessa instalação local serão enviados para a
          instalação central do município e unificados. Após o término do envio, a instalação local será desativada.
          Deseja continuar?
        </Text>
      </ModalBody>
      <ModalFooter>
        <HFlow justifyContent='flex-end'>
          <Button kind='normal' onClick={handleFecharModal}>
            Cancelar
          </Button>
          <Button kind='danger' onClick={onUnificarClicked}>
            Unificar
          </Button>
        </HFlow>
      </ModalFooter>
    </Modal>
  )
}
